export const INITIAL_STEP = 'profile'

export const headHelmetProps = {
  title: 'Corretor Parceiro EmCasa: Receba Comissão Indicando Imóveis',
  description:
    'Com o Programa Corretor Parceiro EmCasa, você indica imóveis e recebe 15% da nossa, comissão de venda. Descubra como funciona!',
  url: 'https://emcasa.com/corretor-parceiro/cadastrar',
  image: `${process.env.CLOUDINARY_IMAGE_URL}/share/share-2`,
  canonical: 'https://emcasa.com/corretor-parceiro'
}

export const loggerAction = {
  onload: 'partnerbroker-signup-page',
  stepback: 'partnerbroker-signup-step-back',
  stepforward: 'partnerbroker-signup-step-forward',
  onloadprofile: 'partnerbroker-signup-profile',
  profilemodalopen: 'partnerbroker-signup-profile-modal-open',
  profilemodallink: 'partnerbroker-signup-profile-modal-link',
  onloaddistricts: 'partnerbroker-signup-neighborhood',
  profilenext: 'partnerbroker-signup-profile-next',
  neighborhoodsnext: 'partnerbroker-signup-neighborhood-next',
  neighborhoodsback: 'partnerbroker-signup-neighborhood-back',
  oninputchange: 'partnerbroker-signup-step-profile-',
  onstepdistrictschange: 'partnerbroker-signup-step-neighborhood-districts',
  send: 'partnerbroker-signup-send',
  sendsuccess: 'partnerbroker-signup-send-success',
  senderror: 'partnerbroker-signup-send-error',
  success: 'partnerbroker-signup-success',
  successbutton: 'partnerbroker-signup-success-button',
  error: 'partnerbroker-signup-error',
  errorbutton: 'partnerbroker-signup-error-button'
}

export const DROPDOWN_OPTION_HEIGHT = 60
